import { render, staticRenderFns } from "./Toapplyfor.vue?vue&type=template&id=ec096bb2&scoped=true"
import script from "./Toapplyfor.vue?vue&type=script&lang=js"
export * from "./Toapplyfor.vue?vue&type=script&lang=js"
import style0 from "./Toapplyfor.vue?vue&type=style&index=0&id=ec096bb2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec096bb2",
  null
  
)

export default component.exports